<template>
	<div id="later">
		<!-- 搜索 -->
		<el-row :gutter="20">
			<el-col :span="4"><el-input v-model="search.serialNumber" placeholder="搜索样本编号" suffix-icon="icon dficonfont icon-search"></el-input></el-col>
			<!-- <el-col :span="4">
				<el-date-picker value-format="yyyy/MM/dd HH:mm:ss" v-model="search.serialTime" type="datetime" placeholder="选择样本时间" style="width: 100%;"></el-date-picker>
			</el-col> -->
			<el-col :span="4"><el-input v-model="search.serialPhone" placeholder="搜索电话号码"></el-input></el-col>
			<el-col :span="4"><el-button type="primary" @click="searchInquire">查询</el-button></el-col>
			<el-col :span="2" style="float: right;"><el-button type="primary" style="float: right;" @click="fanghui">放回</el-button></el-col>
		</el-row>
		<!-- 表格 -->
		<div class="later_table">
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
				<el-table-column type="selection"></el-table-column>
				<el-table-column prop="s_Code" label="样本编号"></el-table-column>
				<el-table-column prop="pi_AreaCode" label="电话区号"></el-table-column>
				<el-table-column prop="s_Tel" label="电话号码"></el-table-column>
				<el-table-column prop="address" label="国家及代号"></el-table-column>
				<el-table-column prop="address" label="省、市"></el-table-column>
				<el-table-column prop="address" label="地区"></el-table-column>
				<el-table-column prop="address" label="局"></el-table-column>
				<el-table-column prop="address" label="局号"></el-table-column>
				<el-table-column prop="address" label="拨打次数"></el-table-column>
				<el-table-column fixed="right" label="操作">
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.row)" type="text" size="small">放回</el-button>
						<el-button type="text" size="small" @click="gain(scope.row)">获取</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 分页 -->
		<el-pagination
			class="laterPagin"
			@current-change="handleCurrentChange"
			:current-page="ipaging.currentPage"
			:page-size="ipaging.pageSize"
			layout="total, prev, pager, next, jumper"
			:total="ipaging.total"
		></el-pagination>
	</div>
</template>

<script>
export default {
	data() {
		return {
			sampleCode: '', //
			ipaging: {
				total: 0,
				pageSize: 10,
				currentPage: 1
			},
			search: {
				serialNumber: '', //样本编号
				serialTime: '', //样本时间
				serialPhone: '' //约访电话
			},
			tableData: [], //列表数据
			projectId: '' //项目id
		};
	},
	computed: {
		prCode() {
			return this.$store.state.pr_Code;
		}
	},
	watch: {
		prCode(newId, oldId) {
			if (newId) {
				this.projectId = newId;
				this.loadData();
			}
		}
	},
	mounted() {
		this.projectId = this.$store.state.pr_Code == '' ? window.localStorage.getItem('prCode') : this.$store.state.pr_Code;
		this.loadData();
	},
	methods: {
		// 获取
		gain(value) {
			console.log(value);
			
			
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.checkSample}`,
				data: {
					prCode: this.$store.state.pr_Code, //项目id
					sampleId: value.s_Code //样本id
				},
				cb(res) {
					console.log(res.result)
					if (res.result == undefined) {
						that.$router.push({
							path: '/workbench',
							query: {
								dialtype: 'sh',
								scode: value.s_Code,
								pindex: value.intermitPage,
								phone: value.s_Tel,
								areaCode: value.pi_AreaCode
								// extensionNumber: value.extensionNumber
							}
						});
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		// 放回
		handleClick(value) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.putItBackOneSample}`,
				data: {
					prCode: this.$store.state.pr_Code, //项目id
					sampleCode: value.s_Code //样本id
				},
				cb(res) {
					if (res.result == '111111111111') {
						that.$message.success(res.msg);
						that.loadData();
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		// 查询
		searchInquire() {
			this.loadData();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.ipaging.currentPage = val;
			this.loadData();
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		fanghui() {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.putItBackOneSample}`,
				data: {
					prCode: this.$store.state.pr_Code, //项目id
					sampleCode: this.sampleCode //样本id
				},
				cb(res) {
					if (res.result == '111111111111') {
						that.$message.success(res.msg);
						that.loadData();
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		handleSelectionChange(val) {
			let temporary = [];
			val.forEach(item => {
				temporary.push(item.s_Code);
			});
			this.sampleCode = temporary.toString();
		},
		inquire() {
			let paramsData = {
				prCode: this.projectId,
				pageIndex: this.ipaging.currentPage,
				pageSize: this.ipaging.pageSize,
				SCode: this.search.serialNumber,
				intermitPage: this.search.serialTime,
				phone: this.search.serialPhone
			};
			return paramsData;
		},
		loadData() {
			if (this.projectId == '' || this.projectId == null) {
				this.$message.error('请先选择项目');
				return false;
			}
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.queryCallLaterRecordList}`,
				data: this.inquire(),
				cb(res) {
					if (res.result == '111111111111') {
						console.log(res);
						that.tableData = res.data;
						that.ipaging.total = res.total;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
#later {
	width: 100%;
	height: 100%;
	min-height: 600px;
	// padding: 36px 30px;
	.later_search {
	}
	.later_table {
		width: 100%;
		margin-top: 20px;
	}
	.laterPagin {
		margin-top: 50px;
		padding-bottom: 20px;
		float: right;
	}
}
</style>
